<template>
    <div class="modal fade" id="completionModal" tabindex="-1" aria-labelledby="completionModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">

                <div class="modal-body">
                    <form @submit.prevent="submitCompletion" enctype="multipart/form-data">
                        <div class="row">

                            <!-- Vehicle Make -->
                            <div class="col-md-6 form-group mb-3">
                                <label class="control-label">Vehicle Make</label>
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="formData.vehicle_make"
                                    placeholder="Enter vehicle make"
                                />
                            </div>

                            <!-- Vehicle Model -->
                            <div class="col-md-6 form-group mb-3">
                                <label class="control-label">Vehicle Model</label>
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="formData.vehicle_model"
                                    placeholder="Enter vehicle model"
                                />
                            </div>

                            <!-- Registration Date -->
                            <div class="col-md-6 form-group mb-3">
                                <label class="control-label">Registration Date</label>
                                <input
                                    class="form-control"
                                    type="date"
                                    v-model="formData.registration_date"
                                />
                            </div>

                            <!-- Engine Number -->
                            <div class="col-md-6 form-group mb-3">
                                <label class="control-label">Engine Number</label>
                                <input 
                                    class="form-control" 
                                    type="text" 
                                    v-model="formData.engine_no" 
                                    placeholder="Enter engine number" 
                                />
                            </div>

                            <!-- Chassis Number -->
                            <div class="col-md-6 form-group mb-3">
                                <label class="control-label">Chassis Number</label>
                                <input 
                                    class="form-control" 
                                    type="text" 
                                    v-model="formData.chassis_no" 
                                    placeholder="Enter chassis number" 
                                />
                            </div>

                            <!-- RC Image -->
                            <div class="col-md-6 form-group mb-3">
                                <label class="control-label">RC Image</label>
                                <input 
                                    class="form-control" 
                                    type="file" 
                                    @change="handleFileUpload($event, 'rc_image')"
                                    accept="image/*"
                                    ref="rcImageInput"
                                />
                                <div v-if="existingImages.rc_image" class="mt-2">
                                    <small class="text-muted">Current image:</small>
                                    <img :src="imageUrl + existingImages.rc_image" class="img-thumbnail ms-2" width="100" height="100" alt="RC Image">
                                </div>
                                <div v-if="formData.rc_image" class="mt-2">
                                    <small class="text-success">New image selected</small>
                                    <img :src="previewImages.rc_image" class="img-thumbnail ms-2" width="100" height="100" alt="RC Image Preview">
                                </div>
                            </div>

                            <!-- Device Image -->
                            <div class="col-md-6 form-group mb-3">
                                <label class="control-label">Device Image</label>
                                <input 
                                    class="form-control" 
                                    type="file" 
                                    @change="handleFileUpload($event, 'device_image')"
                                    accept="image/*"
                                    ref="deviceImageInput"
                                />
                                <div v-if="existingImages.device_image" class="mt-2">
                                    <small class="text-muted">Current image:</small>
                                    <img :src="imageUrl + existingImages.device_image" class="img-thumbnail ms-2" width="100" height="100" alt="Device Image">
                                </div>
                                <div v-if="formData.device_image" class="mt-2">
                                    <small class="text-success">New image selected</small>
                                    <img :src="previewImages.device_image" class="img-thumbnail ms-2" width="100" height="100" alt="Device Image Preview">
                                </div>
                            </div>

                            <!-- Vehicle Image -->
                            <div class="col-md-6 form-group mb-3">
                                <label class="control-label">Vehicle Image</label>
                                <input 
                                    class="form-control" 
                                    type="file" 
                                    @change="handleFileUpload($event, 'vehicle_image')"
                                    accept="image/*"
                                    ref="vehicleImageInput"
                                />
                                <div v-if="existingImages.vehicle_image" class="mt-2">
                                    <small class="text-muted">Current image:</small>
                                    <img :src="imageUrl + existingImages.vehicle_image" class="img-thumbnail ms-2" width="100" height="100" alt="Vehicle Image">
                                </div>
                                <div v-if="formData.vehicle_image" class="mt-2">
                                    <small class="text-success">New image selected</small>
                                    <img :src="previewImages.vehicle_image" class="img-thumbnail ms-2" width="100" height="100" alt="Vehicle Image Preview">
                                </div>
                            </div>

                            <template v-if="isCameraProduct">
                                <!-- Camera 2 -->
                                <div class="col-md-6 form-group mb-3">
                                    <label class="control-label">Camera Name 1</label>
                                    <input
                                        class="form-control"
                                        type="text"
                                        v-model="formData.camera_name"
                                        placeholder="Enter camera 1 name/serial"
                                    />
                                </div>
                                <!-- Camera 2 -->
                                <div class="col-md-6 form-group mb-3">
                                    <label class="control-label">Camera 2</label>
                                    <input
                                        class="form-control"
                                        type="text"
                                        v-model="formData.camera_2"
                                        placeholder="Enter camera 2 name/serial"
                                    />
                                </div>

                                <!-- Camera 3 -->
                                <div class="col-md-6 form-group mb-3">
                                    <label class="control-label">Camera 3</label>
                                    <input
                                        class="form-control"
                                        type="text"
                                        v-model="formData.camera_3"
                                        placeholder="Enter camera 3 name/serial"
                                    />
                                </div>

                                <!-- Camera 4 -->
                                <div class="col-md-6 form-group mb-3">
                                    <label class="control-label">Camera 4</label>
                                    <input
                                        class="form-control"
                                        type="text"
                                        v-model="formData.camera_4"
                                        placeholder="Enter camera 4 name/serial"
                                    />
                                </div>
                            </template>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearForm">Cancel</button>
                    <button type="button" class="btn btn-primary" @click="submitCompletion" :disabled="isSubmitting">
                        <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        {{ isSubmitting ? 'Processing...' : 'Submit' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, inject, onMounted, computed } from 'vue';
import { Modal } from "bootstrap";
import { useRouter } from 'vue-router';

const props = defineProps({
    job: {
        type: Object,
        required: true
    },
    job_id: {
        type: [String, Number],
        required: true
    }
});

const emit = defineEmits(['completed']);

const router = useRouter();
const imageUrl = inject('imageUrl');

const isCameraProduct = computed(() => Number(props.job?.product_id) === 2);

// File input refs (needed to clear file selection)
const rcImageInput = ref(null);
const deviceImageInput = ref(null);
const vehicleImageInput = ref(null);

// Form data
const formData = ref({
    vehicle_make: '',
    vehicle_model: '',
    registration_date: '',
    engine_no: '',
    chassis_no: '',
    rc_image: null,
    device_image: null,
    vehicle_image: null,
    camera_name: '',
    camera_2: '',
    camera_3: '',
    camera_4: '',
});

// Existing images from job
const existingImages = ref({});

// Preview images for new uploads
const previewImages = ref({});

// Loading state
const isSubmitting = ref(false);

// Modal instance
let completionModal = null;

// File upload handler
const handleFileUpload = (event, fieldName) => {
    const file = event.target.files[0];
    if (file) {
        formData.value[fieldName] = file;
        
        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
            previewImages.value[fieldName] = e.target.result;
        };
        reader.readAsDataURL(file);
    }
};

// Initialize form with job data
const initializeForm = () => {
    formData.value.vehicle_make = props.job.vehicle_make || '';
    formData.value.vehicle_model = props.job.vehicle_model || '';
    formData.value.registration_date = props.job.registration_date || '';
    formData.value.engine_no = props.job.engine_no || '';
    formData.value.chassis_no = props.job.chassis_no || '';
    if (isCameraProduct.value) {
        formData.value.camera_name = props.job.camera_name || '';
        formData.value.camera_2 = props.job.camera_2 || '';
        formData.value.camera_3 = props.job.camera_3 || '';
        formData.value.camera_4 = props.job.camera_4 || '';
    } else {
        formData.value.camera_name = '';
        formData.value.camera_2 = '';
        formData.value.camera_3 = '';
        formData.value.camera_4 = '';
    }
    
    // Set existing images
    existingImages.value = props.job.images || {};
    
    // Clear previous uploads
    formData.value.rc_image = null;
    formData.value.device_image = null;
    formData.value.vehicle_image = null;
    
    previewImages.value = {};
};

// Clear form function - reset to original job data
const clearForm = () => {
    // Reset to original job data (auto-filled fields)
    formData.value.vehicle_make = props.job.vehicle_make || '';
    formData.value.vehicle_model = props.job.vehicle_model || '';
    formData.value.registration_date = props.job.registration_date || '';
    formData.value.engine_no = props.job.engine_no || '';
    formData.value.chassis_no = props.job.chassis_no || '';
    if (isCameraProduct.value) {
        formData.value.camera_name = props.job.camera_name || '';
        formData.value.camera_2 = props.job.camera_2 || '';
        formData.value.camera_3 = props.job.camera_3 || '';
        formData.value.camera_4 = props.job.camera_4 || '';
    } else {
        formData.value.camera_name = '';
        formData.value.camera_2 = '';
        formData.value.camera_3 = '';
        formData.value.camera_4 = '';
    }
    
    // Clear only the new file uploads (keep existing images)
    formData.value.rc_image = null;
    formData.value.device_image = null;
    formData.value.vehicle_image = null;
    
    // Clear preview images (new uploads)
    previewImages.value = {};
    
    // Keep existing images from job data
    existingImages.value = props.job.images || {};
    
    // Clear file inputs
    const fileInputs = [rcImageInput, deviceImageInput, vehicleImageInput];
    fileInputs.forEach((inputRef) => {
        if (inputRef?.value) inputRef.value.value = '';
    });
};

// Show modal
const showModal = () => {
    initializeForm();
    if (completionModal) {
        completionModal.show();
    }
};

// Hide modal
const hideModal = () => {
    if (completionModal) {
        completionModal.hide();
    }
    clearForm();
};

// Submit completion
const submitCompletion = async () => {
    isSubmitting.value = true;

    try {
        // Prepare form data
        const submitData = new FormData();
        submitData.append('job_id', props.job_id);
        
        // Always append fields (even if empty) to avoid undefined array key errors
        submitData.append('vehicle_make', formData.value.vehicle_make || '');
        submitData.append('vehicle_model', formData.value.vehicle_model || '');
        submitData.append('registration_date', formData.value.registration_date || '');
        submitData.append('engine_no', formData.value.engine_no || '');
        submitData.append('chassis_no', formData.value.chassis_no || '');
        if (isCameraProduct.value) {
            submitData.append('camera_name', formData.value.camera_name || '');
            submitData.append('camera_2', formData.value.camera_2 || '');
            submitData.append('camera_3', formData.value.camera_3 || '');
            submitData.append('camera_4', formData.value.camera_4 || '');
        }
        
        // Only append images if new uploads exist
        if (formData.value.rc_image) {
            submitData.append('rc_image', formData.value.rc_image);
        }
        if (formData.value.device_image) {
            submitData.append('device_image', formData.value.device_image);
        }
        if (formData.value.vehicle_image) {
            submitData.append('vehicle_image', formData.value.vehicle_image);
        }
        // Emit completion event with form data
        emit('completed', submitData);
        
        hideModal();
    } catch (error) {
        console.error('Error submitting completion:', error);
        alert('Error submitting completion. Please try again.');
        clearForm(); // Clear form on error
    } finally {
        isSubmitting.value = false;
    }
};

// Initialize modal on mount
onMounted(() => {
    completionModal = new Modal(document.getElementById('completionModal'));
});

// Expose methods
defineExpose({
    showModal,
    hideModal,
    clearForm
});
</script>

<style scoped>
.img-thumbnail {
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
}

.text-success {
    color: #198754 !important;
}

.text-muted {
    color: #6c757d !important;
}
</style>
